import React, { createContext, useContext, useEffect, useState } from "react";

const CONSENT_KEY = "drn_consent_v1";

const ConsentContext = createContext({
  consent: null,
  setConsent: () => {},
  showBanner: false,
});

function updateGoogleConsent(granted) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const state = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
}

export function ConsentProvider({ children }) {
  const [consent, setConsentState] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        setConsentState(parsed);
        updateGoogleConsent(parsed.granted);
      } else {
        setShowBanner(true);
      }
    } catch (e) {
      setShowBanner(true);
    }
  }, []);

  const setConsent = (granted) => {
    const record = { granted, at: new Date().toISOString() };
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
    } catch (e) {}
    setConsentState(record);
    setShowBanner(false);
    updateGoogleConsent(granted);
  };

  return (
    <ConsentContext.Provider value={{ consent, setConsent, showBanner }}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  return useContext(ConsentContext);
}
